import type { RequestFunction } from "@kanda-libs/openapi-io-ts-runtime";
import * as t from "io-ts";
import * as parameters from "../components/parameters";
import * as schemas from "../components/schemas";

export type ExportEnterpriseDailyReportRequestParameters = {
  datetime_from?: string;
  datetime_to?: string;
};

export const exportEnterpriseDailyReportOperation = {
  path: "/api/enterprise/all/export-daily-report",
  method: "post",
  responses: {
    "200": { _tag: "JsonResponse", decoder: t.array(schemas.ExportJSON) },
    default: { _tag: "JsonResponse", decoder: schemas.Error },
  },
  parameters: [parameters.datetime_from, parameters.datetime_to],
  requestDefaultHeaders: { Accept: "application/json" },
} as const;

export type ExportEnterpriseDailyReportRequestFunction = RequestFunction<
  { params: ExportEnterpriseDailyReportRequestParameters },
  Array<schemas.ExportJSON>
>;
